import { z } from "zod/v4-mini";

import { TandemEventDefinition } from "../TandemTypes";

export type AlertType =
  | "ALERT_LOW_LIPO_CHARGE" // Low power (2)
  | "ALERT_VERY_LOW_LIPO_CHARGE" // Very low power (3)
  | "ALERT_INCOMPLETE_BOLUS" // Incomplete bolus (11)
  | "ALERT_INCOMPLETE_FILL_TUBING" // Incomplete fill tubing (14)
  | "ALERT_INCOMPLETE_FILL_CANNULA" // Incomplete fill cannula (15)
  | "ALERT_INCOMPLETE_IDP_PROGRAMMING" // Incomplete IDP programming (16)
  | "ALERT_TRANSMITTER_EXPIRED" // Transmitter expired (39)
  | "ALERT_TRANSMITTER_BATTERY_1" // Low transmitter battery (22 days remaining) (44)
  | "ALERT_TRANSMITTER_BATTERY_2" // Low transmitter battery (14 days remaining) (45)
  | "ALERT_TRANSMITTER_BATTERY_3" // Low transmitter battery (less than 13 days remaining) (46)
  | "ALERT_CGM_UNAVAILABLE" // CGM unavailable (48)
  | "ALERT_CIQ_HIGH" // Control-IQ High (50)
  | "ALERT_CIQ_LOW" // Control-IQ Low (51)
  | "ALERT_MAX_INSULIN"; // Max insulin (52)

export type AlertActivatedPayload = {
  alert_id: number;
};

export type AlertActivatedEvent = {
  alertId: number;
  alertType?: AlertType;
};

const alertActivatedSchema = z.object({
  alert_id: z.number(),
});

export const LID_ALERT_ACTIVATED = {
  value: 0x04,
  name: "Alert Activated Event",
  format: "i............",
  fields: ["alert_id"],
  postprocess: rec => ({
    alertId: rec.alert_id,
    alertType: getAlertType(rec.alert_id),
  }),
  schema: alertActivatedSchema,
} as const satisfies TandemEventDefinition<AlertActivatedPayload, AlertActivatedEvent>;

const getAlertType = (alertId: number): AlertType | undefined => {
  switch (alertId) {
    case 2:
      return "ALERT_LOW_LIPO_CHARGE";
    case 3:
      return "ALERT_VERY_LOW_LIPO_CHARGE";
    case 11:
      return "ALERT_INCOMPLETE_BOLUS";
    case 14:
      return "ALERT_INCOMPLETE_FILL_TUBING";
    case 15:
      return "ALERT_INCOMPLETE_FILL_CANNULA";
    case 16:
      return "ALERT_INCOMPLETE_IDP_PROGRAMMING";
    case 39:
      return "ALERT_TRANSMITTER_EXPIRED";
    case 44:
      return "ALERT_TRANSMITTER_BATTERY_1";
    case 45:
      return "ALERT_TRANSMITTER_BATTERY_2";
    case 46:
      return "ALERT_TRANSMITTER_BATTERY_3";
    case 48:
      return "ALERT_CGM_UNAVAILABLE";
    case 50:
      return "ALERT_CIQ_HIGH";
    case 51:
      return "ALERT_CIQ_LOW";
    case 52:
      return "ALERT_MAX_INSULIN";
    default:
      return undefined;
  }
};
